export enum CustomListType {
    Unspecified = 0,
    FamilyMember = 1
}